module.exports = __webpack_public_path__ + "img/milkBanner.11dfc6fd.png";